import { DateRange } from '@mint-lib/tw-components/patterns';
import { endOfDay, format, isWithinInterval, parseISO } from 'date-fns';

import { SERVER_DATE_FORMAT } from '../constants/shared.js';
import { type DateRangeModel } from '../types/filters.js';

export const getRangeFromModel = (model: DateRangeModel | null): DateRange => {
  return {
    from: model?.valueFrom ? parseISO(model.valueFrom) : undefined,
    to: model?.valueTo ? parseISO(model.valueTo) : undefined,
  };
};

export const getModelFromRange = (range?: DateRange): DateRangeModel | null => {
  if (!range?.from || !range?.to) {
    return null;
  }

  return {
    condition: 'between',
    valueFrom: format(range.from, SERVER_DATE_FORMAT),
    valueTo: format(range.to, SERVER_DATE_FORMAT),
  };
};

export const isDateRangeModelsEqual = (
  modelA: DateRangeModel | null,
  modelB: DateRangeModel | null,
): boolean => {
  if (modelA === modelB) {
    return true;
  }

  if (!modelA || !modelB) {
    return false;
  }

  return (
    modelA.condition === modelB.condition &&
    modelA.valueFrom === modelB.valueFrom &&
    modelA.valueTo === modelB.valueTo
  );
};

export const doesValuePassFilter = (
  model: DateRangeModel | null,
  value?: string | null,
) => {
  if (!value) {
    return false;
  }

  if (!model) {
    return true;
  }

  const rowDate = parseISO(value);
  const startDate = parseISO(model.valueFrom);
  const endDate = endOfDay(parseISO(model.valueTo));

  return isWithinInterval(rowDate, { start: startDate, end: endDate });
};
